export var Labels={paymentProcessing:"Bayaran sedang diproses"};